/**
 * A small intimate salon — the "cabinet" of a classical picture gallery. Low
 * weight in open ground, but its compact footprint is the one shape that fits
 * the tight pockets where the route folds near itself, so hemmed-in wings can
 * always seat a first room and grow out from there.
 */

import { rectSegments } from '../hang';

const cabinet = {
  id: 'cabinet',
  role: 'wing',
  weight: 1.2,

  plan(rand, { axis }) {
    const long = 6.5 + rand() * 1.5;
    const cross = 5.5 + rand() * 1.2;
    return {
      w: axis === 'x' ? long : cross,
      d: axis === 'x' ? cross : long,
      height: 5.6,
    };
  },

  segments(node) {
    return rectSegments(node, { longStyle: 'cluster', shortStyle: 'cluster' });
  },

  build(node, T) {
    return T.standardShell(node, T.kit, { corniceH: 0.4 });
  },
};

export default cabinet;
